import { createContext, useCallback, useContext } from 'react';
import defaultShortcuts from '../data/default.json';
import { getKey } from '../KeyHelper';
import { getActionsByKey } from '../utils';
export const KeyboardShortcutsContext = /*#__PURE__*/createContext({
  shortcuts: defaultShortcuts,
  saveShortcuts: () => {},
  actionCache: {
    current: {}
  }
});
export const useKeyboardShortcuts = () => {
  const {
    shortcuts,
    actionCache
  } = useContext(KeyboardShortcutsContext);
  const getActionsByKeyEvent = useCallback(e => {
    const key = getKey(e);
    if (actionCache.current[key] === undefined) {
      actionCache.current[key] = getActionsByKey(key, shortcuts);
    }
    return {
      key,
      actions: actionCache.current[key]
    };
  }, [actionCache, shortcuts]);
  return {
    getActionsByKeyEvent
  };
};
//# sourceMappingURL=useKeyboardShortcuts.js.map